import React, { useContext, useEffect } from 'react';
import { SignalRContext } from '../../contexts/SignalRContext';
import alertify from "alertifyjs";
import { AuthContext } from '../../contexts/AuthContext';

const Footer = props => {
    const { userState } = useContext(AuthContext);
    const { signalRConnection, join } = useContext(SignalRContext);

      useEffect(() => {
          if(userState.isAuthenticated)
          {
              if(signalRConnection.connectionState == 0)
              {
                  signalRConnection.start().then(() => {
                      console.log("SignalR Connected")
                  });
                  console.log('called from footer')
               //   setTimeout(() => join(userState.user.userName), 2000);
              }
          }
      }, []);

      signalRConnection.on('incomingCall', (callingUser) => {
          console.log('SignalR: incoming call from: ' + JSON.stringify(callingUser));

    // Ask if we want to talk
          alertify.confirm(callingUser.userName + ' is calling.  Do you want to chat?', function (e) {
             if (e) {
    // I want to chat
                  signalRConnection.invoke('AnswerCall', true, callingUser).catch(err => console.log(err));

    // So lets go into call mode on the UI
    //  $('body').attr('data-mode', 'incall');
    //    $("#callstatus").text('In Call');
             } else {
    // Go away, I don't want to chat with you
                  signalRConnection.invoke('AnswerCall', false, callingUser).catch(err => console.log(err));
              }
          });
      });


    return (
        <footer className="footer">
            <div className="footer-top">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 col-md-6">
                            <div className="footer-widget footer-about">
                                <div className="footer-about-content">
                                    <p> A complete solution for Hospitals and Clinics. </p>
                                    <div className="social-icon">
                                        <ul>
                                            <li>
                                                <a href="#" target="_blank"><i className="fab fa-facebook-f"></i> </a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank"><i className="fab fa-twitter"></i> </a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank"><i className="fab fa-linkedin-in"></i></a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank"><i className="fab fa-instagram"></i></a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank"><i className="fab fa-dribbble"></i> </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-3 col-md-6">

                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title">For Patients</h2>
                                <ul>
                                    <li><a href="">Search for Doctors</a></li>
                                    <li><a href="">Login</a></li>
                                    <li><a href="">Register</a></li>
                                    <li><a href="">Booking</a></li>
                                    <li><a href="">Patient Dashboard</a></li>
                                </ul>
                            </div>

                        </div>

                        <div className="col-lg-3 col-md-6">

                            <div className="footer-widget footer-menu">
                                <h2 className="footer-title">For Doctors</h2>
                                <ul>
                                    <li><a href="">Appointments</a></li>
                                    <li><a href="">Chat</a></li>
                                    <li><a href="">Login</a></li>
                                    <li><a href="">Register</a></li>
                                    <li><a href="">Doctor Dashboard</a></li>
                                </ul>
                            </div>

                        </div>

                        <div className="col-lg-3 col-md-6">

                            <div className="footer-widget footer-contact">
                                <h2 className="footer-title">Contact Us</h2>
                                <div className="footer-contact-info">
                                    <div className="footer-address">
                                        <span><i className="fas fa-map-marker-alt"></i></span>
                                        <p> Nuremberg <br /> Germany </p>
                                    </div>
                                    <p>
                                        <i className="fas fa-phone-alt"></i>
                                        +49 1515 1587 387
                                            </p>
                                    <p className="mb-0">
                                        <i className="fas fa-envelope"></i>
                                        info@accepire.com
                                            </p>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container-fluid">

                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6 col-lg-6">
                                <div className="copyright-text">
                                    <p className="mb-0">Copyright &copy; 2020 <a href="https://www.accepire.com">Accepire</a>. All rights reserved.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6">

                                <div className="copyright-menu">
                                    <ul className="policy-menu">
                                        <li><a href="">Terms and Conditions</a></li>
                                        <li><a href="">Policy</a></li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};


export default Footer;